import { render, staticRenderFns } from "./MainGallery.vue?vue&type=template&id=4380483b&"
import script from "./MainGallery.vue?vue&type=script&lang=js&"
export * from "./MainGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports